<script setup lang="ts">
import SafeHtml from "@/components/SafeHtml.vue";
import { NavArrowDown } from "@iconoir/vue";
import {
  AccordionContent,
  AccordionHeader,
  AccordionItem,
  AccordionRoot,
  AccordionTrigger,
} from "reka-ui";

defineProps<{
  conversationGuide: string;
}>();
</script>

<template>
  <AccordionRoot type="single" collapsible class="guide-accordion">
    <AccordionItem value="guide">
      <AccordionHeader as="h3">
        <AccordionTrigger class="guide-accordion-trigger">
          Gesprächsleitfaden
          <NavArrowDown aria-hidden="true" />
        </AccordionTrigger>
      </AccordionHeader>
      <AccordionContent class="guide-accordion-content">
        <div class="conversation-guide">
          <SafeHtml :html="conversationGuide" />
        </div>
      </AccordionContent>
    </AccordionItem>
  </AccordionRoot>
</template>

<style scoped>
.guide-accordion {
  padding-inline: var(--spacing-md);
  background-color: var(--bg-color-input);
  border: var(--border-width) solid var(--color-primary);
  border-radius: var(--border-radius-card);

  h3 {
    font-weight: unset;
    font-size: var(--font-size-default);
    padding-block: var(--spacing-sm);
    transition: font-weight 0.2s ease-out;

    &[data-state="open"] {
      font-weight: var(--font-weight-bold);
    }
  }
}

.guide-accordion-trigger {
  display: flex;
  justify-content: space-between;
  align-items: center;
  inline-size: 100%;
  border: none;
  background: none;
  color: inherit;
  font: inherit;
  cursor: pointer;

  &:focus:not(:focus-visible) {
    outline: none;
  }

  > svg {
    transition: transform 0.2s;
  }

  &[data-state="open"] > svg {
    transform: rotate(180deg);
  }
}

.guide-accordion-content {
  overflow: hidden;

  .conversation-guide {
    padding-block: var(--spacing-sm);
  }

  &[data-state="open"] {
    animation: guide-slide-down 0.2s ease-out;
  }

  &[data-state="closed"] {
    animation: guide-slide-up 0.2s ease-out;
  }
}

@keyframes guide-slide-down {
  from {
    block-size: 0;
  }
  to {
    block-size: var(--reka-accordion-content-height);
  }
}

@keyframes guide-slide-up {
  from {
    block-size: var(--reka-accordion-content-height);
  }
  to {
    block-size: 0;
  }
}
</style>
